import { createFileRoute } from "@tanstack/react-router";
import { AuthHeading, AuthLayout } from "../features/auth/components/auth-layout";
import { ForgotPasswordForm } from "../features/auth/components/password-forms";

export const Route = createFileRoute("/forgot-password")({
  component: () => (
    <AuthLayout>
      <AuthHeading
        title="Reset your password"
        subtitle="We email you a link to choose a new one."
      />
      <ForgotPasswordForm />
    </AuthLayout>
  ),
});
